var isKind = require('./isKind');
/**
 */


var isArray = Array.isArray || function (val) {
  return isKind(val, 'Array');
};

module.exports = isArray;